export default __webpack_public_path__ + "static/media/parent1.1a8ae066.jpg";